import { Stack, styled } from "@mui/material";

export const ManagePermissionsFormWrapper = styled(Stack)(({ theme }) => {
	return {
		gap: "var(--flex-gap)",
	};
});
